import { Loader } from '@dapp/multi-lib/ui/loader';
import { useIsMobile } from '@dapp/multi-lib/ui/shared-hooks/useIsMobile';
import { StakingPoolTable } from 'structure/staking/containers/StakingPoolTable';
import { StakingPoolCardList } from 'structure/staking/containers/StakingPoolCardList';
import React from 'react';
import { ModalName } from 'structure/staking/types';
import { useStakingPoolList } from 'structure/staking/hooks/useStakingAPI';
import { StakingProject } from 'api/StakingAPI';

type StakingPoolLiProps = {
  tokenSymbol?: string;
  project?: StakingProject;
  onOpenModal: (modalName: ModalName, poolId: number) => void;
};

export function StakingPoolList({
  onOpenModal,
  tokenSymbol,
  project,
}: StakingPoolLiProps) {
  const showTable = !useIsMobile(1279);

  const stakingPoolList = useStakingPoolList(
    {
      query: {},
    },
    tokenSymbol
  );

  if (stakingPoolList.isLoading || !stakingPoolList.isFetched) {
    return <Loader />;
  }

  if (stakingPoolList.data?.length === 0 && stakingPoolList.isSuccess) {
    return <div>empty list</div>;
  }

  if (showTable) {
    return (
      <StakingPoolTable
        pools={stakingPoolList.data || []}
        project={project}
        onOpenModal={onOpenModal}
      />
    );
  }

  return (
    <StakingPoolCardList
      pools={stakingPoolList.data || []}
      project={project}
      onOpenModal={onOpenModal}
    />
  );
}
